import React from 'react';
import { FormCheck } from '@/shared/components/features/form/FormCheck';
import { FormErrorMessage } from '@/shared/components/features/form/FormErrorMessage';
import { FormSubmitButtons } from '@/shared/components/features/form/FormSubmitButtons';
import { MainContainer } from '@/shared/components/parts/MainContainer';
import { PortalModal } from '@/shared/components/parts/PortalModal';
import { Spacer } from '@/shared/components/parts/Spacer';
import type { UseAccountDeletion } from '../index.hook';

export const ConfirmForm: React.FC<{
  state: UseAccountDeletion['state'];
  invokeDeletion: UseAccountDeletion['invokeDeletion'];
  isLoading: boolean;
}> = ({ state, invokeDeletion, isLoading }) => {
  const [isChecked1, setIsChecked1] = React.useState(false);
  const [isChecked2, setIsChecked2] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  React.useEffect(() => {
    if (state.errorMessage) {
      setIsModalOpen(false);
    }
  }, [state.errorMessage]);

  return (
    <MainContainer>
      <Spacer level={3} />
      <FormErrorMessage message={state.errorMessage} />
      <div className="tw-text-h2 tw-text-main-100">アカウントの削除</div>
      <Spacer level={2} />
      <div>
        下記の内容をご確認の上、チェックボックスにチェックしてください。（必須）
      </div>
      <Spacer level={2} />
      <div className="tw-rounded-4 tw-bg-brand-lv3 tw-p-[1rem]">
        <div className="tw-grid tw-grid-cols-1 tw-gap-[1rem]">
          {[
            {
              id: 'check1',
              text: 'アカウントが削除され、ログインできなくなります。',
              checked: isChecked1,
              onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                setIsChecked1(e.target.checked);
              },
            },
            {
              id: 'check2',
              text: '購入した映像作品が視聴できなくなります。',
              checked: isChecked2,
              onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                setIsChecked2(e.target.checked);
              },
            },
          ].map(({ id, text, checked, onChange }) => (
            <label
              htmlFor={id}
              key={id}
              className="tw-grid tw-cursor-pointer tw-grid-cols-[auto,1fr] tw-items-start tw-gap-[1rem]"
            >
              <div>
                <FormCheck
                  id={id}
                  name={id}
                  checked={checked}
                  onChange={onChange}
                />
              </div>
              <div className="tw-text-base1Title">{text}</div>
            </label>
          ))}
        </div>
      </div>
      <Spacer level={3} />
      <FormSubmitButtons
        buttons={[
          {
            buttonType: 'button',
            text: 'アカウントを削除',
            type: 'button',
            disabled: !isChecked1 || !isChecked2,
            style: {
              opacity: !isChecked1 || !isChecked2 ? 0.3 : 1,
            },
            onClick: () => {
              setIsModalOpen(true);
            },
          },
          {
            buttonType: 'link',
            text: 'キャンセル',
            href: '/',
            buttonStyle: 'secondary',
          },
        ]}
      />
      <Spacer level={4} />
      {isModalOpen && (
        <PortalModal
          title="アカウントの削除"
          primaryButton={{
            text: '削除',
            buttonStyle: 'warning',
            onClick: () => {
              invokeDeletion();
            },
            disabled: isLoading,
          }}
          secondaryButton={{
            text: 'キャンセル',
            buttonStyle: 'cancel',
            onClick: () => {
              setIsModalOpen(false);
            },
            disabled: isLoading,
          }}
        >
          <div>本当に削除してよろしいですか？</div>
        </PortalModal>
      )}
    </MainContainer>
  );
};
